import AboutHeroSection from "../components/AboutHeroSection";
import BentoGridsView from "../components/BentoGridsView";
import BrainsBehind from "../components/BrainsBehind";
import Footer from "../components/Footer";
import LinksTab from "../components/LinksTab";
import Mission from "../components/Mission";
import Partner from "../components/Partner";
import TextCarosul from "../components/TextCarosul";
import Vison from "../components/Vison";
import "./styles/about.css";

const AboutUs = () => {
  return (
    <div className="about-main">
      <AboutHeroSection />
      <BentoGridsView />
      <Vison />
      <Mission />
      <Partner />
      <BrainsBehind />
      <TextCarosul />
      <LinksTab />
      <Footer />
    </div>
  );
};

export default AboutUs;
